export default __webpack_public_path__ + "static/media/upload.f49e85d9.svg";